<style>
	@import '@/assets/css/custom.css';
	
	.hover-bg-light:hover {
		background-color: #f8f9fa !important;
	}
	
	.cursor-pointer {
		cursor: pointer;
	}
</style>

<template>
    <div>
        <Breadcrumbs main="Boards" title="Board Details" />
         
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <div class="card">
                        <div class="card-body">
                            
                            <div class="row mb-3">
								<div class="col-md-8">
									<div class="mm-cart-text">
                                        <table class="product_table">
                                            <thead style="font-size: medium;">
                                                <tr>
                                                    <th>Serial Number</th>
                                                    <th style="text-align: left;">:</th>
                                                    <td style="text-align: right;">{{ board.serial_number }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Board Number</th>
                                                    <th style="text-align: left;">:</th>
                                                    <td style="text-align: right;">{{ board.board_number }}</td>
                                                </tr>
                                                <tr>
                                                    <th>ICCID</th>
                                                    <th style="text-align: left;">:</th>
                                                    <td style="text-align: right;">{{ board.iccid }}</td>
                                                </tr>
                                                <tr>
                                                    <th>IMEI</th>
                                                    <th style="text-align: left;">:</th>
                                                    <td style="text-align: right;">{{ board.imei }}</td>
                                                </tr>
                                                <tr>
                                                    <th>Vendor Name</th>
                                                    <th style="text-align: left;">:</th>
                                                    <td style="text-align: right;">{{ board.vendor_name }}</td>
                                                </tr> 
                                            </thead>
                                        </table>
                                    </div>
								</div>
                                <div class="col-4">
                                    <button v-if="allComponentsCompleted" class="btn btn-success me-2" @click="openFirmwareSuccessModal">
                                        <i class='bx bx-check-circle'></i> Firmware Success
                                    </button>
                                    <router-link :to="{ name: 'boards', query: $route.query }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Board Details
                                        </h4>
                                        
                                        <div class="d-flex justify-content-end px-3 mb-3">
                                            <button class="btn btn-success btn-sm mb-2" :disabled="!canClickFirmwareButton || board.firmware_status == 2" @click="openBoardFirmwareSuccessModal()">Firmware Success</button>
                                        </div>
                                        
                                        <div class="table-responsive product-table">
											<table class="display" id="basic-1">
												<thead>
													<tr align="center">
														<th>Component</th>
														<th>Status</th>
														<th>Remarks</th>
														<th>Action</th>
													</tr>
												</thead>
												<tbody>
													<tr align="center" v-for="data in board_components" :key="data.id">
														<td>{{data.raw_material_name}}</td>
														<td>
															<span class="badge rounded-pill bg-info" v-if="data.status == 1">Pending</span>
															<span class="badge rounded-pill bg-success" v-else-if="data.status == 2">Completed</span>
															<span class="badge rounded-pill bg-danger" v-else-if="data.status == 3">Returned</span>
															<span class="badge rounded-pill bg-warning" v-else-if="data.status == 4">Failed</span>
														</td>
														<td>{{data.remarks}}</td>
														<td>
															<div v-if="data.status == 1">
																<a class="btn btn-success btn-sm mt-3 me-2 mb-2" @click="markTestSuccess(data)">Test Success</a>
																<a class="btn btn-danger btn-sm mt-3 me-2 mb-2" @click="markTestFailed(data)">Test Failed</a>
															</div>
															<div v-if="data.status == 4">
																<a class="btn btn-warning btn-sm mt-3 me-2 mb-2" @click="openReturnModal(data)">Return</a>
																<a class="btn btn-success btn-sm mt-3 me-2 mb-2" @click="openSuccessModal(data)">Success</a>
                                                                <a class="btn btn-info btn-sm mt-3 me-2 mb-2" @click="openResolvedModal(data)">Component Replaced</a>
															</div>
															<div v-if="data.status == 3">
																<a class="btn btn-info btn-sm mt-3 me-2 mb-2" @click="openResolvedModal(data)">Component Replaced</a>
                                                                <a class="btn btn-success btn-sm mt-3 me-2 mb-2" @click="openSuccessModal(data)">Success</a>
															</div>
														</td>  
													</tr>
												</tbody>
											</table>
										</div>
                                    </div>
                                </div> 
                            </div>
                            <div class="row">
                                <div class="col-lg-12 col-md-12 mt-3">
                                    <div header-class="bg-transparent border-light" class="border border-light">
                                        <h4 class="font-size-16 bg-primary  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                                            Components History</h4>

                                        <div class="table-responsive product-table">
                                            <table class="display" id="basic-1">
                                                <thead>
                                                    <tr>
                                                        <th>Component</th>
                                                        <th>Status</th>              
                                                        <th>Remarks</th>
                                                        <th>Updated On</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="logs in component_logs" :key="logs.id">
                                                        <td>{{logs.raw_material_name}}</td>
                                                        <td>
															<span class="badge rounded-pill bg-info" v-if="logs.status == 1">Pending</span>
															<span class="badge rounded-pill bg-success" v-else-if="logs.status == 2">Completed</span>
															<span class="badge rounded-pill bg-danger" v-else-if="logs.status == 3">Returned</span>
															<span class="badge rounded-pill bg-warning" v-else-if="logs.status == 4">Failed</span>
														</td>
                                                        <td>{{logs.remarks}}</td>
                                                        <td>{{logs.converted_updated_at}}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Return Modal -->
        <DynamicModal :title="'Return Board'" id="returnModal">
            <template #body>
                <form @submit.prevent="submitReturn">
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Vendor<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="vendor_id" required disabled>
                                <option value="">--Select Vendor--</option>
                                <option v-for="vendor in vendors" :value="vendor.id">{{ vendor.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Remarks</label>
                            <textarea v-model="returnData.remarks" class="form-control" rows="3" placeholder="Enter return remarks..."></textarea>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-warning me-3">Save & Return</button>
                            <button type="button" class="btn btn-light" @click="closeReturnModal">Close</button>
                        </div>
                    </div>
                </form>
            </template>
        </DynamicModal>

        <!-- Success Modal -->
        <DynamicModal :title="'Mark Success'" id="successModal">
            <template #body>
                <form @submit.prevent="submitSuccess">
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Remarks</label>
                            <textarea v-model="successData.remarks" class="form-control" rows="3" placeholder="Enter success remarks..."></textarea>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-success me-3">Mark Success</button>
                            <button type="button" class="btn btn-light" @click="closeSuccessModal">Close</button>
                        </div>
                    </div>
                </form>
            </template>
        </DynamicModal>

        <!-- Resolved Modal (Component Replaced) -->
        <DynamicModal :title="'Mark Resolved'" id="resolvedModal">
            <template #body>
                <form @submit.prevent="submitResolved">
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Vendor<span class="text-danger">*</span></label>
                            <select class="form-select" v-model="resolvedData.vendor_id" required>
                                <option value="">--Select Vendor--</option>
                                <option v-for="vendor in vendors" :key="vendor.id" :value="String(vendor.id)">{{ vendor.name }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Remarks<span class="text-danger">*</span></label>
                            <textarea v-model="resolvedData.remarks" class="form-control" rows="3" placeholder="Enter resolution remarks..." required></textarea>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Quantity<span class="text-danger">*</span></label>
                            <input type="number" v-model="resolvedData.quantity" class="form-control" placeholder="Enter quantity" required>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-info me-3">Mark Resolved</button>
                            <button type="button" class="btn btn-light" @click="closeResolvedModal">Close</button>
                        </div>
                    </div>
                </form>
            </template>
        </DynamicModal>

        <!-- Firmware Success Modal -->
        <DynamicModal :title="'Firmware Success'" id="firmwareSuccessModal">
            <template #body>
                <form @submit.prevent="submitFirmwareSuccess">
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">IMEI<span class="text-danger">*</span></label>
                            <input v-model="firmwareData.imei" class="form-control" placeholder="Enter IMEI number" required/>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Select ICCID<span class="text-danger">*</span></label>
                            <div class="position-relative">
                                <input 
                                    v-model="firmwareData.iccid_search" 
                                    class="form-control" 
                                    placeholder="Search ICCID..."
                                    @input="searchIccid"
                                    @focus="showIccidSuggestions = true"
                                    @blur="hideIccidSuggestions"
                                    required
                                />
                                <div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
                                    <div 
                                        v-for="iccid in filteredIccidList" 
                                        :key="iccid.id"
                                        class="p-2 border-bottom cursor-pointer hover-bg-light"
                                        @click="selectIccid(iccid)"
                                        style="cursor: pointer;"
                                    >
                                        {{ iccid.iccid }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="firmwareData.selectedIccid">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 2<span class="text-danger">*</span></label>
                            <input v-model="firmwareData.selectedIccid.sim_2" class="form-control" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 1<span class="text-danger">*</span></label>
                            <input v-model="firmwareData.selectedIccid.sim_1" class="form-control" disabled/>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-12">
                            <button type="submit" class="btn btn-success me-3">Mark Firmware Success</button>
                            <button type="button" class="btn btn-light" @click="closeFirmwareSuccessModal">Close</button>
                        </div>
                    </div>
                </form>
            </template>
        </DynamicModal>

        //Board firmware success modal
        <DynamicModal :title="'Board Firmware Success'" id="boardFirmwareSuccessModal">
			<template #body>
				<form @submit.prevent="markBoardFirmwareSuccess" enctype="multipart/form-data">
					<!-- Current Batch Information -->
					<div class="row" v-if="currentBatch">
						<div class="col-md-12">
							<div class="alert alert-info">
								<strong>Current Batch:</strong> {{ currentBatch.batch_number }}<br>
								<strong>Total Boards:</strong> {{ currentBatch.total_boards }}
							</div>
							<button type="button" class="btn btn-success btn-sm mb-3" @click="createNewBatch">Start New Batch</button>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">Device Model<span class="text-danger">*</span></label>
                        	<select v-model="device_model_id" class="form-select" required>
								<option value="">Select Device Model</option>
								<option v-for="model in deviceModels" :key="model.id" :value="model.id">{{ model.modelName }}</option>
							</select>
                        </div>
					</div>
					<div class="row">
						<div class="col-md-12 form-group mt-2">
                            <label class="control-label">IMEI<span class="text-danger">*</span></label>
                        	<input v-model="imei" class="form-control" rows="3"/>
                        </div>
					</div>
					<div class="row">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">Select ICCID<span class="text-danger">*</span></label>
                        	<div class="position-relative">
								<input 
									v-model="iccid_search" 
									class="form-control" 
									placeholder="Search ICCID..."
									@input="searchIccid"
									@focus="showIccidSuggestions = true"
									@blur="hideIccidSuggestions"
								/>
								<div v-if="showIccidSuggestions && filteredIccidList.length > 0" class="position-absolute w-100 bg-white border rounded shadow-sm" style="z-index: 1000; max-height: 200px; overflow-y: auto;">
									<div 
										v-for="iccid in filteredIccidList" 
										:key="iccid.id"
										class="p-2 border-bottom cursor-pointer hover-bg-light"
										@click="selectIccid(iccid)"
										style="cursor: pointer;"
									>
										{{ iccid.iccid }}
									</div>
								</div>
							</div>
                        </div>
                    </div>

					<div class="row" v-if="selectedIccid">
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 1<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_1" class="form-control" disabled/>
                        </div>
                        <div class="col-md-12 form-group mt-2">
                            <label class="control-label">SIM 2<span class="text-danger">*</span></label>
                        	<input v-model="selectedIccid.msisdn_2" class="form-control" disabled/>
                        </div>
                    </div>

                    <div class="row">
						<div class="col-md-12 form-group mt-2">
							<label class="control-label">Firmware Version<span class="text-danger">*</span></label>
                        	<select v-model="firmware_version" class="form-select">
								<option value="">Select</option>
								<option value="AWNVer 6.49.2+494">AWNVer 6.49.2+494</option>
							</select>
						</div>
					</div>

					<div class="row">
						<div class="col-md-12 form-group mt-2">
							<button type="submit" class="btn btn-primary me-3">Mark Firmware Success</button>
							<button class="btn btn-light" type="button" @click="closeModal()">Close</button>
						</div>
					</div>
				</form>
			</template>
		</DynamicModal>
    </div>	
</template>

<script>
import { onMounted, ref } from 'vue'
import { Modal } from 'bootstrap'
import DynamicModal from '@/components/dynamic_modal.vue'

export default {
    name: "Board Details",
    components: {
        DynamicModal
    },
    
    setup() {
        // No refs needed for modals
        return {}
    },

    data() {
        return {
            board_data: [
                { id: 1, component: "Component 1", status: 1, remarks: "" },
                { id: 2, component: "Component 2", status: 2, remarks: "Hand over to repair team" },
                { id: 3, component: "Component 3", status: 3, remarks: "Not working, so returned to manufacturer" },
                { id: 4, component: "Component 4", status: 4, remarks: "" },
                { id: 5, component: "Component 5", status: 3, remarks: "" },
            ],
            returnData: {
                vendor_id: '',
                remarks: ''
            },
            successData: {
                remarks: ''
            },
            resolvedData: {
                vendor_id: '',
                remarks: '',
                quantity: ''
            },
            returnModalInstance: null,
            successModalInstance: null,
            resolvedModalInstance: null,
            firmwareSuccessModalInstance: null,
            boardFirmwareSuccessModalInstance: null,
            vendor_id: '',
            // Firmware Success Modal Data
            firmwareData: {
                imei: '',
                iccid_search: '',
                selectedIccid: null
            },
            showIccidSuggestions: false,
            filteredIccidList: [],
            
            // Board Firmware Success Modal Data
            imei: '',
            iccid_search: '',
            selectedIccid: null,
            deviceModels: [],
            device_model_id: '',
            firmware_version: '',
            board_components:[],
            board:{},
            component_logs:[],
            
            vendors:[],
            iccid_list: [],
            currentBatch: null,
            loading: false,
            errors: {},
        }
    },

    mounted() {
        // Initialize Bootstrap modals
        this.returnModalInstance = new Modal(document.getElementById('returnModal'))
        this.successModalInstance = new Modal(document.getElementById('successModal'))
        this.resolvedModalInstance = new Modal(document.getElementById('resolvedModal'))
        this.firmwareSuccessModalInstance = new Modal(document.getElementById('firmwareSuccessModal'))
        this.boardFirmwareSuccessModalInstance = new Modal(document.getElementById('boardFirmwareSuccessModal'))
    },

    computed: {
        allComponentsCompleted() {
            return this.board_data.every(component => component.status === 2)
        },
        canClickFirmwareButton() {
            if (!Array.isArray(this.board_components) || this.board_components.length === 0) {
                return false
            }
            // Button is clickable only if ALL components have status 1 (Pending) or 2 (Completed)
            return this.board_components.every(component => component.status === 1 || component.status === 2)
        }
    },
    created(){
        this.boardDetail();
        this.fetchVendors();
    },

    methods: {

            getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},

            boardDetail(page_url = null) {
				this.getToken();
				let url = '/staffs/boardDetails?board_id=' + this.$route.params.id;
				page_url = page_url || url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
                        this.board = responseData.board;
                        this.board_components = responseData.board_components;
						this.component_logs = responseData.component_logs;
                        this.vendor_id = responseData.board.vendor_id;
					})
					.catch((err) => console.log(err));
			},

            fetchVendors() {
                this.getToken();
                this.$axios
                    .get("/staffs/vendorsList", { headers: { Authorization: "Bearer " + this.token } })
                    .then((res) => {
                        var responseData = res.data;
                        this.vendors = responseData.data;
                    })
            },

            
        markTestSuccess(data) {
            this.getToken();
            this.$swal({
                icon: 'question',
                title: "Confirm",
                text: `Are you sure you want to mark ${data.raw_material_name || data.component} as test success?`,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                confirmButtonColor: '#28a745',
                cancelButtonText: 'No',
                position: "center",
                showConfirmButton: true,
                timer: '',
                toast: false,
                cancelButtonColor: '#efefef',
            }).then((result) => {
                if (result.value) {
                    const config = {
                        headers: {
                            "Content-type": "application/json",
                            "Authorization": "Bearer " + this.token,
                        },
                    };

                    let url = "staffs/boardComponentFirmwareSuccess";
                    let formData = new FormData();
                    formData.append("component_id", data.component_id);
                    formData.append("board_id", this.$route.params.id);
                    
                    this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                            if (response.data.status) {
                                this.$swal("", response.data.message, "success");
                                this.boardDetail();
                            } else {
                                this.$swal("", response.data.message, "error");
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            if (error.response && error.response.data && error.response.data.message) {
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        });
                }
            })
        },

        markTestFailed(data) {
            this.getToken();
            this.$swal({
                icon: 'warning',
                title: "Confirm",
                text: `Are you sure you want to mark ${data.raw_material_name || data.component} as test failed?`,
                showCancelButton: true,
                confirmButtonText: 'Yes',
                confirmButtonColor: '#e64942',
                cancelButtonText: 'No',
                position: "center",
                showConfirmButton: true,
                timer: '',
                toast: false,
                cancelButtonColor: '#efefef',
            }).then((result) => {
                if (result.value) {
                    const config = {
                        headers: {
                            "Content-type": "application/json",
                            "Authorization": "Bearer " + this.token,
                        },
                    };

                    let url = "staffs/boardComponentFirmwareFailure";
                    let formData = new FormData();
                    formData.append("component_id", data.component_id || data.id);
                    formData.append("board_id", this.$route.params.id);

                    this.$axios
                        .post(url, formData, config)
                        .then((response) => {
                            if (response.data.status) {
                                this.$swal("", response.data.message, "success");
                                this.boardDetail();
                            } else {
                                this.$swal("", response.data.message, "error");
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                            if (error.response && error.response.data && error.response.data.message) {
                                this.$swal("", error.response.data.message, "error");
                            } else {
                                this.$swal("", "Something went wrong", "error");
                            }
                        });
                }
            })
        },

        // Status 3: Return and Success buttons
        openReturnModal(data) {
            this.returnData = {
                vendor_id: this.vendor_id,
                remarks: '',
                component_id: data.component_id || data.id
            }
            this.returnModalInstance.show()
        },

        closeReturnModal() {
            this.returnModalInstance.hide()
        },

        submitReturn() {

            this.getToken();

            const config = {
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "staffs/boardReturnToVendor";
            let formData = new FormData();
            formData.append("component_id", this.returnData.component_id);
            formData.append("board_id", this.$route.params.id);
            formData.append("remarks", this.returnData.remarks);

            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.closeReturnModal()
                        this.$swal('', response.data.message, 'success')
                        this.boardDetail()
                    } else {
                        this.$swal('', response.data.message, 'error')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$swal('', error.response.data.message, 'error')
                    } else {
                        this.$swal('', 'Something went wrong', 'error')
                    }
                })
        },

        openSuccessModal(data) {
            this.successData = {
                remarks: '',
                component_id: data.component_id || data.id
            }
            this.successModalInstance.show()
        },

        closeSuccessModal() {
            this.successModalInstance.hide()
        },

        submitSuccess() {
            this.getToken();

            const config = {
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "staffs/boardComponentFirmwareSuccess";
            let formData = new FormData();
            formData.append("component_id", this.successData.component_id);
            formData.append("board_id", this.$route.params.id);
            formData.append("remarks", this.successData.remarks);

            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.closeSuccessModal()
                        this.$swal('', response.data.message, 'success')
                        this.boardDetail()
                    } else {
                        this.$swal('', response.data.message, 'error')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$swal('', error.response.data.message, 'error')
                    } else {
                        this.$swal('', 'Something went wrong', 'error')
                    }
                })
        },

        // Status 4: Resolved button
        openResolvedModal(data) {
            const rawId = (this.board && (this.board.vendor_id != null && this.board.vendor_id !== ''))
                ? this.board.vendor_id
                : (this.vendor_id != null && this.vendor_id !== '' ? this.vendor_id : '');
            const boardVendorId = rawId !== '' ? String(rawId) : '';
            this.resolvedData = {
                vendor_id: boardVendorId,
                remarks: '',
                quantity: '',
                component_id: data.component_id || data.id
            };
            this.resolvedModalInstance.show();
        },

        closeResolvedModal() {
            this.resolvedModalInstance.hide()
        },

        submitResolved() {
            this.getToken();

            const config = {
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "staffs/componentResolvedByVendor";
            let formData = new FormData();
            formData.append("component_id", this.resolvedData.component_id);
            formData.append("board_id", this.$route.params.id);
            formData.append("vendor_id", this.resolvedData.vendor_id);
            formData.append("remarks", this.resolvedData.remarks);
            formData.append("quantity", this.resolvedData.quantity);

            this.$axios
                .post(url, formData, config)
                .then((response) => {
                    if (response.data.status) {
                        this.closeResolvedModal()
                        this.$swal('', response.data.message, 'success')
                        this.boardDetail()
                    } else {
                        this.$swal('', response.data.message, 'error')
                    }
                })
                .catch((error) => {
                    console.log(error);
                    if (error.response && error.response.data && error.response.data.message) {
                        this.$swal('', error.response.data.message, 'error')
                    } else {
                        this.$swal('', 'Something went wrong', 'error')
                    }
                })
        },

        // Firmware Success Modal Methods
        openBoardFirmwareSuccessModal() {
            if (!this.canClickFirmwareButton) {
                return
            }
            // Reset form data
            this.imei = ''
            this.iccid_search = ''
            this.selectedIccid = null
            this.showIccidSuggestions = false
            this.filteredIccidList = []
            this.device_model_id = ''

            // Pre-fill from board details when board already has data
            if (this.board && Object.keys(this.board).length > 0) {
                if (this.board.imei) {
                    this.imei = this.board.imei
                }
                if (this.board.model_id != null && this.board.model_id !== undefined) {
                    this.device_model_id = String(this.board.model_id)
                }
                if (this.board.iccid) {
                    this.iccid_search = this.board.iccid
                    const matchingSim = this.iccid_list.find(s => String(s.iccid) === String(this.board.iccid))
                    if (matchingSim) {
                        this.selectedIccid = matchingSim
                    } else {
                        this.selectedIccid = {
                            iccid: this.board.iccid,
                            msisdn_1: this.board.primary_mobile_number || '',
                            msisdn_2: this.board.secondary_mobile_number || ''
                        }
                    }
                }
                this.firmware_version = this.board.firmware_version === 'AWNVer 6.49.2+494'
                    ? this.board.firmware_version
                    : ''
            }

            // Fetch ICCID list if not already loaded
            if (this.iccid_list.length === 0) {
                this.fetchIccidList()
            }
            // Fetch current batch and device models
            this.fetchBatch()
            this.fetchDeviceModels()
            // Show the modal
            this.boardFirmwareSuccessModalInstance.show()
        },

        openFirmwareSuccessModal() {
            this.firmwareData = {
                imei: '',
                iccid_search: '',
                selectedIccid: null
            }
            this.showIccidSuggestions = false
            this.filteredIccidList = []

            // Pre-fill from board details when board already has data
            if (this.board && Object.keys(this.board).length > 0) {
                if (this.board.imei) {
                    this.firmwareData.imei = this.board.imei
                }
                if (this.board.iccid) {
                    this.firmwareData.iccid_search = this.board.iccid
                    const matchingSim = this.iccid_list.find(s => String(s.iccid) === String(this.board.iccid))
                    if (matchingSim) {
                        this.firmwareData.selectedIccid = matchingSim
                    } else {
                        this.firmwareData.selectedIccid = {
                            iccid: this.board.iccid,
                            sim_1: this.board.primary_mobile_number || '',
                            sim_2: this.board.secondary_mobile_number || ''
                        }
                    }
                }
                if (this.board.firmware_version) {
                    this.firmware_version = this.board.firmware_version
                }
            }
            if (this.iccid_list.length === 0) {
                this.fetchIccidList()
            }
            this.firmwareSuccessModalInstance.show()
        },

        closeFirmwareSuccessModal() {
            this.firmwareSuccessModalInstance.hide()
        },

        searchIccid() {
            if (this.firmwareData.iccid_search.trim() === '') {
                this.filteredIccidList = []
                return
            }
            
            this.filteredIccidList = this.iccid_list.filter(iccid => 
                iccid.iccid.toLowerCase().includes(this.firmwareData.iccid_search.toLowerCase())
            )
        },

        selectIccid(iccid) {
            this.firmwareData.selectedIccid = iccid
            this.firmwareData.iccid_search = iccid.iccid
            this.showIccidSuggestions = false
        },

        hideIccidSuggestions() {
            setTimeout(() => {
                this.showIccidSuggestions = false
            }, 200)
        },

        submitFirmwareSuccess() {
            if (!this.firmwareData.imei || !this.firmwareData.selectedIccid) {
                this.$swal('Error!', 'Please fill all required fields', 'error')
                return
            }

            // Here you would typically send the data to your API
            // For now, we'll just show a success message
            this.closeFirmwareSuccessModal()
            this.$swal('Success!', 'Board firmware marked as successful', 'success')
        },

        fetchIccidList() {
            this.getToken();
            this.$axios
                .get("/staffs/getAvailableSimList", { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    var responseData = res.data.data;
                    this.iccid_list = responseData.sims;
                })
                .catch((err) => console.log(err));
        },

        searchIccid() {
            if (this.iccid_search.trim() === '') {
                this.filteredIccidList = [];
                this.showIccidSuggestions = false;
                return;
            }
            
            this.filteredIccidList = this.iccid_list.filter(iccid => 
                iccid.iccid.toLowerCase().includes(this.iccid_search.toLowerCase())
            );
            
            if (this.filteredIccidList.length > 0) {
                this.showIccidSuggestions = true;
            }
        },

        selectIccid(iccid) {
            this.selectedIccid = iccid;
            this.iccid_search = iccid.iccid;
            this.showIccidSuggestions = false;
        },

        hideIccidSuggestions() {
            setTimeout(() => {
                this.showIccidSuggestions = false;
            }, 200);
        },

        markBoardFirmwareSuccess()
        {
            this.getToken();
            this.errors = {};

            const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            // Validation
            if (!this.device_model_id) {
                this.$swal("", "Please select a device model", "error");
                return;
            }
            if (!this.imei || !this.selectedIccid || !this.selectedIccid.iccid) {
                this.$swal("", "Please fill all required fields (IMEI and ICCID)", "error");
                return;
            }
            if (!this.firmware_version) {
                this.$swal("", "Please select a firmware version", "error");
                return;
            }

            let url = "staffs/boardFirmwareSuccess";
            let formData = new FormData();
            formData.append("board_id", this.$route.params.id);
            formData.append("device_model", this.device_model_id);
            formData.append("imei", this.imei);
            formData.append("iccid", this.selectedIccid.iccid);
            formData.append("firmware_version", this.firmware_version || "");

            this.$axios
            .post(url, formData, config)
            .then((response) => {
                if (response.data.status) {
                    this.$swal("", response.data.message, "success");
                } else {
                    this.$swal("", response.data.message, "error");
                }
                this.closeModal();
                this.boardDetail();
            })
            .catch((error) => {
                console.log(error);
                console.log(error.response);
                if (error.response) {
                    if (error.response.data.message) {
                        this.errors = error.response.data.message;
                        this.$swal("", error.response.data.message, "error");
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                } else {
                    this.$swal("", "Something went wrong", "error");
                }
            });
        },

        closeModal() {
            this.boardFirmwareSuccessModalInstance.hide()
            // Reset form data
            this.imei = ''
            this.iccid_search = ''
            this.selectedIccid = null
            this.showIccidSuggestions = false
            this.filteredIccidList = []
            this.device_model_id = ''
            this.firmware_version = ''
        },

        fetchDeviceModels() {
            this.getToken();
            this.$axios
                .get("/staffs/getDeviceModel", { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    if (res.data.status && res.data.data) {
                        this.deviceModels = res.data.data;
                    } else {
                        this.deviceModels = [];
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.deviceModels = [];
                });
        },

        fetchBatch() {
            this.getToken();
            this.$axios
                .get("/staffs/fetchBatch", { headers: { Authorization: "Bearer " + this.token } })
                .then((res) => {
                    if (res.data.status && res.data.data) {
                        this.currentBatch = res.data.data;
                    } else {
                        this.currentBatch = null;
                    }
                })
                .catch((err) => {
                    console.log(err);
                    this.currentBatch = null;
                });
        },

        createNewBatch() {
            this.getToken();
            const config = {
                headers: {
                    "Content-type": "multipart/form-data",
                    "Accept": "application/json",
                    "Authorization": "Bearer " + this.token,
                },
            };

            let url = "staffs/createBatch";
            this.loading = true;

            this.$axios
                .post(url, {}, config)
                .then((response) => {
                    if (response.data.status && response.data.data) {
                        this.currentBatch = {
                            batch_number: response.data.data.batch_number,
                            total_boards: 0
                        };
                        this.$swal("", "New batch created successfully", "success");
                    } else {
                        this.$swal("", response.data.message || "Failed to create batch", "error");
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.loading = false;
                    if (error.response) {
                        if (error.response.data.message) {
                            this.$swal("", error.response.data.message, "error");
                        } else {
                            this.$swal("", "Something went wrong", "error");
                        }
                    } else {
                        this.$swal("", "Something went wrong", "error");
                    }
                });
        },

    }
}
</script>